<mat-card>
    <mat-card-title>Register</mat-card-title>
    <mat-card-content>
        <app-create-user (userCreateSuccess)="onUserCreateSuccess($event)"></app-create-user>
    </mat-card-content>
</mat-card>
